
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/auth/login');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-700 to-yellow-400 flex items-center justify-center relative overflow-hidden">
      {/* Background Animation Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
        <div className="absolute bottom-32 right-16 w-24 h-24 bg-yellow-300/20 rounded-full animate-bounce"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-blue-300/30 rounded-full animate-ping"></div>
      </div>

      {/* Main Content */}
      <div className="text-center z-10 animate-fade-in-up">
        {/* Logo Icon */}
        <div className="w-24 h-24 mx-auto mb-6 bg-white/20 rounded-3xl flex items-center justify-center backdrop-blur-sm animate-scale-in">
          <i className="ri-calculator-line text-4xl text-white"></i>
        </div>

        {/* App Name */}
        <h1 
          className="text-4xl font-bold text-white mb-4 animate-slide-up"
          style={{fontFamily: "Pacifico, serif"}}
        >
          الحاسبة المالية
        </h1>

        {/* Subtitle */}
        <p className="text-white/80 text-lg mb-8 animate-fade-in-delayed">
          تحكم في أموالك بذكاء
        </p>

        {/* Loading Animation */}
        <div className="flex justify-center space-x-2 space-x-reverse">
          <div className="w-3 h-3 bg-white rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes scale-in {
          from {
            opacity: 0;
            transform: scale(0.5);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-in-delayed {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out;
        }

        .animate-scale-in {
          animation: scale-in 0.8s ease-out 0.2s both;
        }

        .animate-slide-up {
          animation: slide-up 0.8s ease-out 0.5s both;
        }

        .animate-fade-in-delayed {
          animation: fade-in-delayed 1s ease-out 0.8s both;
        }
      `}</style>
    </div>
  );
}
